import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { Confirm } from "../../components/confirm";
import { deleteContract } from "../../services/contract";
import { useLocale } from "../../stores/locale";
import { navigateBack } from "../../utils/navigate-back";

export function ContractDelete() {
  const navigate = useNavigate();
  const locale = useLocale((state) => state);
  const queryClient = useQueryClient();
  const { id } = useParams();

  if (!id) {
    throw new Error("Contract ID is required");
  }

  const [loading, setLoading] = useState(false);

  const closeModal = () => {
    navigateBack(navigate, "/admin/contract");
  };

  return (
    <Confirm
      header={locale.get("contract.confirmDelete")}
      loading={loading}
      onClose={closeModal}
      onConfirm={() => {
        (async () => {
          setLoading(true);
          try {
            await deleteContract(id);
            await Promise.all([
              queryClient.invalidateQueries({ queryKey: ["contracts"] }),
              queryClient.invalidateQueries({ queryKey: ["contract", id] }),
            ]);
          } finally {
            setLoading(false);
            closeModal();
          }
        })();
      }}
    />
  );
}
